<script>
	import CardTip from '$lib/shared/ui/CardTip.svelte';
</script>

<!-- 3 blue cards on left side -->

<div
	class="pointer-events-auto absolute top-[10rem] -left-[8rem] z-10 sm:top-[9rem] sm:-left-[3rem]"
>
	<div
		class="scale-[0.4] rotate-[20deg] transition duration-300 ease-in-out sm:scale-75 sm:hover:scale-[.80]"
	>
		<CardTip
			nameStreamer="Patrick Melton"
			tipType="voice"
			avatar="/static/images/blue-card-image1.avif"
			amount="$10.00"
			received="less than a minute ago"
			>Love the show! Keep up the great work!
		</CardTip>
	</div>
</div>
<div
	class="pointer-events-auto absolute top-[18rem] -left-[8rem] z-10 sm:top-[21rem] sm:-left-[2rem]"
>
	<div
		class="scale-[0.4] -rotate-[10deg] transition duration-300 ease-in-out hover:scale-90 sm:scale-[.85]"
	>
		<CardTip
			nameStreamer="David Chen"
			tipType="text"
			avatar="/static/images/blue-card-image2.avif"
			amount="$10.00"
			received="less than a minute ago"
			>Amazing show!
		</CardTip>
	</div>
</div>

<div
	class="pointer-events-auto absolute top-[20rem] -left-[13rem] z-10 sm:top-[29rem] sm:-left-[11rem]"
>
	<div
		class="scale-[0.4] rotate-[12deg] transition duration-300 ease-in-out hover:scale-90 sm:scale-[.85]"
	>
		<CardTip
			nameStreamer="Emily Brown"
			tipType="voice"
			avatar="/static/images/blue-card-image3.avif"
			amount="$100.00"
			received="10 minutes ago"
			>Supporting your channel from way back. The content just keeps getting better and better!
		</CardTip>
	</div>
</div>

<!-- 3 pink cards on right side -->

<div
	class="pointer-events-auto absolute top-[9rem] -right-[13rem] z-10 sm:top-[8rem] sm:-right-[5rem]"
>
	<div
		class="scale-[0.4] -rotate-[20deg] transition duration-300 ease-in-out hover:scale-90 sm:scale-[.85]"
	>
		<CardTip
			nameStreamer="Michael John"
			tipType="voice"
			avatar="/static/images/pink-card-image1.avif"
			amount="$25.00"
			received="30 minutes ago"
			tertiary
			>Thank you for always providing such entertaining and informative shows. Keep it up!
		</CardTip>
	</div>
</div>

<div
	class="pointer-events-auto absolute top-[18rem] -right-[6rem] z-10 sm:top-[21rem] sm:-right-[3rem]"
>
	<div
		class="scale-[0.4] rotate-[7deg] transition duration-300 ease-in-out hover:scale-90 sm:scale-[.85]"
	>
		<CardTip
			nameStreamer="Chris Green"
			tipType="text"
			avatar="/static/images/pink-card-image2.avif"
			amount="$5.00"
			received="less than a minute ago"
			tertiary
			>Catch you tomorrow!
		</CardTip>
	</div>
</div>

<div
	class="pointer-events-auto absolute top-[21rem] -right-[12rem] z-10 sm:top-[31rem] sm:-right-[5rem]"
>
	<div
		class="scale-[0.4] -rotate-[10deg] transition duration-300 ease-in-out hover:scale-90 sm:scale-[.85]"
	>
		<CardTip
			nameStreamer="Sophia Kim"
			tipType="voice"
			avatar="/static/images/pink-card-image3.avif"
			amount="$10.00"
			received="less than a minute ago"
			tertiary
			>Keep stacking those wins! Wish I could be this good.
		</CardTip>
	</div>
</div>
